import { render } from "./Worktop.vue?vue&type=template&id=95162f46"
import script from "./Worktop.vue?vue&type=script&lang=js"
export * from "./Worktop.vue?vue&type=script&lang=js"

import "./Worktop.vue?vue&type=style&index=0&id=95162f46&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__